import React from 'react';
import { ArrowDown, ArrowUp, Trash2 } from 'lucide-react';

export default function BotonesOrden({ indice, total, onMover, onEliminar, etiqueta, testId }) {
  const clase = 'rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 disabled:opacity-30';
  return (
    <div className="flex items-center gap-0.5">
      <button type="button" onClick={() => onMover(-1)} disabled={indice === 0} className={clase} aria-label={`Subir ${etiqueta}`} title="Subir" data-testid={`${testId}-subir`}><ArrowUp className="h-4 w-4" /></button>
      <button type="button" onClick={() => onMover(1)} disabled={indice === total - 1} className={clase} aria-label={`Bajar ${etiqueta}`} title="Bajar" data-testid={`${testId}-bajar`}><ArrowDown className="h-4 w-4" /></button>
      {onEliminar && (
        <button type="button" onClick={onEliminar} className="rounded-md p-1.5 text-red-500 transition-colors hover:bg-red-50" aria-label={`Eliminar ${etiqueta}`} title="Eliminar" data-testid={`${testId}-eliminar`}><Trash2 className="h-4 w-4" /></button>
      )}
    </div>
  );
}
